import { render, staticRenderFns } from "./PublicLeagueView.vue?vue&type=template&id=05f0cd62&scoped=true"
import script from "./PublicLeagueView.vue?vue&type=script&lang=js"
export * from "./PublicLeagueView.vue?vue&type=script&lang=js"
import style0 from "./PublicLeagueView.vue?vue&type=style&index=0&id=05f0cd62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f0cd62",
  null
  
)

export default component.exports